import { HttpService, WidgetStyle } from '@sdbn/appclient';
import { Component, OnInit } from '@angular/core';
import { ContextChange } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';

const MODE_DAILY = 'dialy';
const MODE_HOURLY = 'hourly';

@Component({
  selector: 'app-forecast',
  templateUrl: './forecast.component.html',
  styleUrls: ['./forecast.component.scss']
})
export class ForecastComponent extends AbstractWidgetComponent implements OnInit {


  private ONE_DAY_DURATION: number = 24 * 60 * 60 * 1000;

  hourlyOccupancyUrl: string;

  selectedDate = new Date();
  data: any;

  constructor(
    public translationService: TranslationService,
    private http: HttpService) {
    super();
  }

  ngOnInit() {
    this.loadReport();
  }

  public back() {
    this.selectedDate = new Date(this.selectedDate.getTime() - this.ONE_DAY_DURATION);
    this.loadReport();
  }

  public forward() {
    this.selectedDate = new Date(this.selectedDate.getTime() + this.ONE_DAY_DURATION);
    this.loadReport();
  }

  private loadReport() {

    this.data = null;

    this.http.postWithContext(`${environment.reportingEndpoint}/stationoccupancy`, { date: this.selectedDate, period: 'hours' })
      .subscribe(
        response => {
          this.data = response;
        }
      );

  }

  public printHourlyReport() {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'listexcel');

    // keep focus in current window
    window.focus();

    const url = `${environment.reportingEndpoint}/print-stationoccupancy-hourly`;

    this.http.postWithArraybufferResponse<any>(url, this.selectedDate).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
